export class ContactMediumModel {
  contactMediumId: number;
  contactMediumType: string;
  description: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/contact-medium-model.ts